<template>
    <div>
        <!-- Filtros -->
        <div class="card mb-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>ID</label>
                            <input
                                v-model="filters.checklist_template_id"
                                type="text"
                                class="form-control"
                                placeholder="Digite o ID"
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Nome</label>
                            <v-select
                                v-model="filters.nome"
                                :options="nomeOptions"
                                label="nome"
                                :reduce="t => t.nome"
                                placeholder="Digite ou selecione"
                                taggable
                                push-tags
                                :create-option="t => ({ nome: t })"
                            >
                                <template #no-options>Nenhum checklist encontrado</template>
                            </v-select>
                        </div>
                    </div>
                    <div v-if="isAdminLogged" class="col-md-4">
                        <div class="form-group">
                            <label>Empresa</label>
                            <v-select
                                v-model="filters.company_name"
                                :options="companyOptions"
                                label="name"
                                :reduce="c => c.name"
                                placeholder="Digite ou selecione"
                                taggable
                                push-tags
                                :create-option="c => ({ name: c })"
                            >
                                <template #no-options>Nenhuma empresa encontrada</template>
                            </v-select>
                        </div>
                    </div>
                    <div :class="isAdminLogged ? 'col-md-2' : 'col-md-6'">
                        <div class="form-group">
                            <label>&nbsp;</label>
                            <div class="d-flex">
                                <button @click="applyFilters" class="btn btn-primary mr-2">
                                    <i class="fas fa-search"></i> Filtrar
                                </button>
                                <button @click="clearFilters" class="btn btn-secondary">
                                    <i class="fas fa-times"></i> Limpar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <base-crud
                    :key="crudKey"
                    ref="usersCrud"
                    crudName="Checklists"
                    newText="Novo"
                    :table="table"
                    :columns="columns"
                    :options="options"
                    :endPoint="endPoint"
                    :enableAdd="true"
                    :enableEdit="true"
                    :enableDelete="true"
                    :enableView="false"
                    :enableReset="false"
                    :dataForm="dataForm"
                    :extra="extraButtons"
                    @duplicar="duplicar"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    components: {
        BaseCrud,
        vSelect,
    },

    data() {
        return {
            table: "checklistTemplateTable",
            showMessageImport: false,
            usersCrud: {},
            pages: [],
            url: "",
            columns: [],
            endPoint: "checklisttemplates",
            filters: {
                checklist_template_id: null,
                nome: null,
                company_name: null,
            },
            crudKey: 0,
            nomeOptions: [],
            companyOptions: [],
            dataForm: {},
            extraButtons: [
                {
                    id: 1,
                    name: 'duplicar',
                    title: 'Duplicar Checklist',
                    label: '',
                    icon: 'fas fa-copy',
                    class: 'btn btn-crud duplicate',
                },
            ],
            options: {
                filterByColumn: true,
                debounce: 1000,
                filterable: [],
                pagination: {
                    chunk: 10,
                    dropdown: false,
                    nav: "scroll",
                },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    checklist_template_id: "ID",
                    nome: "Nome",
                    company_label: "Empresa",
                    actions: "Ações",
                },
                texts: {
                    filter: "Pesquisar:",
                    count: "Exibindo {from} a {to} de {count} registros|{count} registros|Um registro",
                    first: "Primeiro",
                    last: "Último",
                    filterPlaceholder: "Pesquisar",
                    limit: "Resultados:",
                    page: "Página:",
                    noResults: "Nenhum resultado encontrado",
                    filterBy: "Filtrar por {column}",
                    loading: "Carregando...",
                    defaultOption: "Selecione {column}",
                    columns: "Colunas",
                },
                sortable: ["checklist_template_id", "nome"],
                customFilters: [],
                sortIcon: {
                    base: "fas",
                    up: "fa-chevron-up",
                    down: "fa-chevron-down",
                    is: "fa-sort",
                },
                listColumns: {},
                templates: {
                    company_label(h, row) {
                        return row.company && row.company.name ? row.company.name : "";
                    },
                    units_label(h, row) {
                        if (!Array.isArray(row.units) || !row.units.length) {
                            return "";
                        }

                        return row.units
                            .map(unit => unit.name)
                            .filter(Boolean)
                            .join(", ");
                    },
                },
                requestFunction: function (data) {
                    const requestData = {
                        params: {
                            ...data,
                            query: "",
                            with: ["company", "units"],
                        },
                    };

                    return axios
                        .get(this.url, requestData)
                        .catch(
                            function (e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                },
            },
        };
    },

    computed: {
        loggedUser() {
            return this.$store.state.auth?.user || this.$store.state.user || null;
        },

        isAdminLogged() {
            return Number(this.loggedUser?.perfil_id) === 1;
        },
    },

    methods: {
        makeFormData() {
            const fd = new FormData();
            const fileImport = document.getElementById("fileImport");

            fd.append(
                "fileImport",
                fileImport && fileImport.files[0] ? fileImport.files[0] : ""
            );

            return fd;
        },

        exportar() {
            const url = this.$store.state.api + "checklisttemplates/export";

            if (window.cordova) {
                const fileTransfer = new FileTransfer();
                const uri = encodeURI(url);
                const fileURL = "Download//Relatório.pdf";

                fileTransfer.download(
                    uri,
                    fileURL,
                    () => {
                        this.$message("Sucesso", "Download realizado com sucesso", "success");
                    },
                    () => {
                        this.$message("Erro", "Erro ao realizar download", "error");
                    }
                );

                return;
            }

            window.open(url, "_blank").focus();
        },

        setupColumns() {
            if (this.isAdminLogged) {
                this.columns = [
                    "checklist_template_id",
                    "nome",
                    "company_label",
                    "actions",
                ];

                this.options.filterable = [
                    "checklist_template_id",
                    "nome",
                ];

                return;
            }

            this.columns = [
                "checklist_template_id",
                "nome",
                "company_label",
                "actions",
            ];

            this.options.filterable = [
                "checklist_template_id",
                "nome",
            ];
        },

        applyFilters() {
            this.options.requestFunction = (data) => {
                const params = {
                    ...data,
                    query: "",
                    with: ["company", "units"],
                };

                if (this.filters.checklist_template_id) {
                    params.checklist_template_id = this.filters.checklist_template_id;
                }
                if (this.filters.nome) {
                    params.nome = this.filters.nome;
                }
                if (this.filters.company_name) {
                    params.company_name = this.filters.company_name;
                }

                return axios
                    .get(this.$store.state.api + "checklisttemplates", { params })
                    .catch((e) => { console.error(e); });
            };
            this.crudKey++;
        },

        clearFilters() {
            this.filters = {
                checklist_template_id: null,
                nome: null,
                company_name: null,
            };
            this.options.requestFunction = (data) => {
                return axios
                    .get(this.$store.state.api + "checklisttemplates", {
                        params: { ...data, query: "", with: ["company", "units"] },
                    })
                    .catch((e) => { console.error(e); });
            };
            this.crudKey++;
        },

        duplicar({ row }) {
            this.$router.push('/checklisttemplates/duplicate/' + row.checklist_template_id);
        },

        async loadFilterOptions() {
            try {
                const res = await axios.get(
                    this.$store.state.api + "checklisttemplates?paginated=false"
                );
                this.nomeOptions = res.data.data || [];

                if (this.isAdminLogged) {
                    const compRes = await axios.get(
                        this.$store.state.api + "companies?paginated=false&status=1"
                    );
                    this.companyOptions = compRes.data.data || [];
                }
            } catch (e) {
                console.error("Erro ao carregar opções de filtro:", e);
            }
        },
    },

    mounted() {
        this.setupColumns();
        this.loadFilterOptions();
    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}

.uploading-image {
    display: flex;
    border-radius: 10px;
    width: 100px;
    height: 100px;
}
</style>